var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpTooltip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0C3.136 0 0 3.136 0 7C0 10.864 3.136 14 7 14C10.864 14 14 10.864 14 7C14 3.136 10.864 0 7 0ZM6.895 11.2C6.405 11.2 6.013 10.808 6.013 10.318C6.013 9.821 6.405 9.443 6.895 9.443C7.392 9.443 7.77 9.821 7.77 10.318C7.77 10.801 7.392 11.2 6.895 11.2ZM9.002 6.02C8.47 6.797 7.966 7.042 7.693 7.539C7.63 7.658 7.588 7.756 7.56 7.952C7.518 8.274 7.259 8.526 6.93 8.526H6.902C6.531 8.526 6.237 8.211 6.272 7.84C6.293 7.609 6.349 7.364 6.482 7.14C6.825 6.531 7.476 6.167 7.854 5.628C8.253 5.061 8.029 3.997 6.895 3.997C6.377 3.997 6.048 4.27 5.838 4.592C5.684 4.83 5.362 4.914 5.089 4.802C4.739 4.655 4.585 4.221 4.802 3.899C5.229 3.262 5.943 2.8 6.881 2.8C7.917 2.8 8.624 3.269 8.988 3.864C9.296 4.368 9.478 5.313 9.002 6.02Z",
    fill: "#8797AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpTooltip);
export default __webpack_public_path__ + "static/media/help-tooltip.257252add15e527fb827eaa7a9ec944f.svg";
export { ForwardRef as ReactComponent };